
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing/bt-pricing",
      function () {
        return require("private-next-pages/pricing/bt-pricing.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pricing/bt-pricing"])
      });
    }
  